import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import CloseIcon from '@material-ui/icons/Close';
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'

import confirm from '../../confirm'

import api from "../../../api/backend"

const DialogTitle = withStyles(theme => ({
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit,
        top: theme.spacing.unit,
        color: theme.palette.grey[500],
    },
}))(props => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root}>
            <Typography variant="title">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit,
    },
}))(MuiDialogActions);

class Editor extends Component {
    state = {
        open: false, title: '', description: ''
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    updateDepartment = () => {
        const { department } = this.props
        const { title, description } = this.state
        api.updateDepartment(department.id, { title, description }).then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ open: false })
                if (this.props.onUpdateCompleted) {
                    this.props.onUpdateCompleted()
                }
            } else {
                console.error('ไม่สามารถบันทึกกลุ่มวิชาได้')
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    deleteDepartment = () => {
        const { department } = this.props

        confirm(`ต้องการลบกลุ่มวิชา '${department.title}' ใช่หรือไม่?`).then(
            (result) => {
                api.deleteDepartment(department.id).then(([response, json]) => {
                    if (response.status === 200) {
                        this.setState({ open: false })
                        if (this.props.onUpdateCompleted) {
                            this.props.onUpdateCompleted()
                        }
                    } else {
                        console.error('ไม่สามารถลบกลุ่มวิชาได้')
                    }
                }).catch(() => {
                    console.error('ไม่สามารถเชื่อมต่อ service ได้')
                })
            },
            (result) => { }
        )
    }

    toggleDepartment = () => {
        const { department } = this.props
        api.toggleDepartment(department.id).then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ open: false })
                if (this.props.onUpdateCompleted) {
                    this.props.onUpdateCompleted()
                }
            } else {
                console.error('ไม่สามารถลบกลุ่มวิชาได้')
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    componentWillMount() {
        const { title, description } = this.props.department
        this.setState({ title, description })
    }

    render() {
        const { title, description } = this.state
        const { department } = this.props
        return (
            <React.Fragment>
                <IconButton aria-label="Edit" onClick={this.handleClickOpen}>
                    <EditIcon />
                </IconButton>
                <IconButton aria-label="CheckBox" onClick={this.toggleDepartment}>
                    {department.deactivated ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
                <IconButton aria-label="Delete" onClick={this.deleteDepartment}>
                    <DeleteIcon />
                </IconButton>

                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">แก้ไขกลุ่มวิชา</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={24} >
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="title"
                                    name="title"
                                    label="ชื่อกลุ่มวิชา"
                                    fullWidth
                                    value={title}
                                    onChange={(event) => { this.setState({ title: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="description"
                                    name="description"
                                    label="รายละเอียด"
                                    fullWidth
                                    multiline
                                    rows={6}
                                    value={description}
                                    onChange={(event) => { this.setState({ description: event.target.value }) }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            ยกเลิก
                        </Button>
                        <Button onClick={this.updateDepartment} color="primary">
                            บันทึก
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default Editor;